import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const FileFolderIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        id="FileFolderIcon"
        data-testid="FileFolderIcon"
        className="bloxicon"
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
      >
        <path
          fill="currentColor"
          d="M22.776 1.232h-6.522c-.299 0-.588.11-.813.308L7.903 8.23a1.222 1.222 0 0 1-.813.308H1.224C.55 8.537 0 9.086 0 9.764v8.138c0 .6.549 1.087 1.224 1.087h21.55c.675 0 1.224-.487 1.224-1.087V2.32c0-.6-.549-1.087-1.225-1.087h.003Z"
        />
        <path
          fill="currentColor"
          d="m7.293 6.51 3.845-3.412a.246.246 0 0 0 .005-.362L8.909.642a.984.984 0 0 0-.668-.265H.91C.409.377 0 .76 0 1.23v4.362c0 .678.549 1.227 1.224 1.227H6.48c.299 0 .588-.11.813-.309Z"
        />
      </svg>
    </SvgIcon>
  );
};

export default FileFolderIcon;
